import { EdgeValidateProPromoCodeRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ValidateProPromoCode } from '@/modules/auth/use-cases'

export function makeValidateProPromoCode(): ValidateProPromoCode {
  return new EdgeValidateProPromoCodeRepository(makeSupabaseEdgeHttpClient()).execute
}
